export default {
  infoBanner: {
    infoText:
      '<1>Like this track?</1> Create your own using Loudly’s AI Music Generator',
    buttonText: 'Generate track',
  },
};
